import { FC, memo, SVGProps } from 'react';

import classNames from 'classnames';

import { ICONS_SVG_PATH, ICONS_SVG_VERSION } from '@telialt/assets/src/constants';

import { IconProps } from './model';

type Props = IconProps & SVGProps<SVGSVGElement>;

const SvgIcon: FC<Props> = ({ type, className, style, ...rest }) => {
    const classList = classNames('icon', className);
    const url = `${ICONS_SVG_PATH}?${ICONS_SVG_VERSION}#${type}`;

    return (
        <svg {...rest} className={classList} style={style}>
            <use xlinkHref={url} />
        </svg>
    );
};

export default memo(SvgIcon);
